import { DossierId } from '../dossier/types';

import {
    GetInTripReviewsFailureAction,
    GetInTripReviewsRequestAction,
    GetInTripReviewsSuccessAction,
    NormalizedInTripReview,
    RemoveInTripReviewAction,
    RemoveInTripReviewFailureAction,
    RemoveInTripReviewSuccessAction,
} from './types';

export const fetchInTripReviewsRequestAction = 'inTripReview/FETCH_ALL_REQUEST';
export const fetchInTripReviewsSuccessAction = 'inTripReview/FETCH_ALL_SUCCESS';
export const fetchInTripReviewsFailureAction = 'inTripReview/FETCH_ALL_FAILURE';
export const removeInTripReviewAction = 'inTripReview/REMOVE_REQUEST';
export const removeInTripReviewSuccessAction = 'inTripReview/REMOVE_SUCCESS';
export const removeInTripReviewFailureAction = 'inTripReview/REMOVE_FAILURE';

export const getInTripReviewsRequest = (): GetInTripReviewsRequestAction => {
    return {
        type: fetchInTripReviewsRequestAction,
    };
};

export const getInTripReviewsSuccess = (
    response: NormalizedInTripReview,
): GetInTripReviewsSuccessAction => ({
    type: fetchInTripReviewsSuccessAction,
    response,
});

export const getInTripReviewsFailure = (error: string): GetInTripReviewsFailureAction => ({
    type: fetchInTripReviewsFailureAction,
    error,
});

export const removeInTripReview = (dossierId: DossierId): RemoveInTripReviewAction => ({
    type: removeInTripReviewAction,
    dossierId,
});

export const removeInTripReviewSuccess = (): RemoveInTripReviewSuccessAction => ({
    type: removeInTripReviewSuccessAction,
});

export const removeInTripReviewFailure = (error: string): RemoveInTripReviewFailureAction => ({
    type: removeInTripReviewFailureAction,
    error,
});
